/* eslint-disable @typescript-eslint/unbound-method */
import client from './node-client';
export { createInstance } from './node-client';
export var add = client.add, groupIdentify = client.groupIdentify, identify = client.identify, init = client.init, logEvent = client.logEvent, remove = client.remove, revenue = client.revenue, setGroup = client.setGroup, setOptOut = client.setOptOut, track = client.track, flush = client.flush;
export { Revenue, Identify } from '@amplitude/analytics-core';
import * as Types_1 from '@amplitude/analytics-types';
export { Types_1 as Types };
//# sourceMappingURL=index.js.map